import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import useCheckPlan from "../../hooks/useCheckPlan";

//
import Moment from "react-moment";
import { Col, Row } from "react-bootstrap";

//
import FilterDropdown from "../../components/general/FilterDropdown";
import StatisticsItem from "../../components/dashboard/StatisticsItem";
import CoinEvents from "../../components/dashboard/CoinEvents";
import TopTenWinners from "../../components/dashboard/TopTenWinners";
import PageHeader from "../../components/general/PageHeader";
import TopFive from "../../components/alert/TopFive";

//
import { showPlanModal } from "../../redux/features/plan/slice";
import { getReports, getTopWinners } from "../../redux/features/coins/actions";

//
import { timeFilter } from "../../constances";

function Dashboard({ plan, showPlanModal }) {
  const [checkPlan] = useCheckPlan();

  const [reportLoading, setReportLoading] = useState(false);
  const [reports, setReports] = useState({});

  const [activeTimeFilter, setActiveTimeFilter] = useState({
    name: "All time",
    value: "all",
    text: "All time",
  });

  const [topWinnerLoading, setTopWinnerLoading] = useState(false);
  const [topWinners, setTopWinners] = useState([]);
  const [activeStatusFilter, setActiveStatusFilter] = useState({
    name: "All Status",
    value: "all",
  });

  /**
   * Check User Plan For Have OR Expire
   */
  const checkPlanExpire = () => {
    if (plan) {
      const epiration = plan.expired_at;
      if (new Date(epiration).getTime() < new Date().getTime()) {
        return "Expired";
      } else {
        return true;
      }
    } else {
      return "No Plan";
    }
  };

  /**
   * Get Reports
   */
  const get_reports = async () => {
    let dateFrom = activeTimeFilter.value;

    // start loading
    setReportLoading(true);

    // request
    await getReports(dateFrom).then((res) => {
      if (res) {
        setReports(res);
      }
    });

    // stop loading
    setReportLoading(false);
  };

  /**
   * Get Top Winners
   */
  const get_top_winners = async () => {
    let dateFrom = activeTimeFilter.value;
    let action = activeStatusFilter.value;
    let limit = 10;

    // start loading
    setTopWinnerLoading(true);

    // request
    await getTopWinners({ dateFrom, action, limit }).then((res) => {
      if (res) {
        setTopWinners(res);
      }
    });

    // stop loading
    setTopWinnerLoading(false);
  };

  useEffect(() => {
    get_reports();

    // eslint-disable-next-line
  }, [activeTimeFilter]);

  useEffect(() => {
    get_top_winners();

    // eslint-disable-next-line
  }, [activeTimeFilter, activeStatusFilter]);

  // useEffect(() => {
  //   if (!checkPlan()) {
  //     showPlanModal({ show: true, step: "choose-plan", type: "plan" });
  //   }

  //   // eslint-disable-next-line
  // }, []);

  return (
    <div id="dashboard">
      {/* Start Header */}
      <PageHeader title="Home" subject="Overview and analytics">
        <FilterDropdown
          filters={timeFilter}
          activeFilter={activeTimeFilter}
          action={(item) => setActiveTimeFilter(item)}
          title="Date"
          icon="las la-calendar-minus"
        />
      </PageHeader>
      {/* End Header */}

      <Row className="main-infos">
        <StatisticsItem
          title="Alerts Success Rate"
          subject={`${reports.successRate || 0}%`}
          text={activeTimeFilter.text}
          loading={reportLoading}
          icon="Success-Rate"
        />

        <StatisticsItem
          title="Total Number of Alerts"
          subject={reports.totalSignals || 0}
          text={activeTimeFilter.text}
          loading={reportLoading}
          icon="Totalnumberofalerts-1"
        />

        <StatisticsItem
          title="Buy | Sell"
          subject={`${reports.sides ? reports.sides.buy : 0} Buy | ${
            reports.sides ? reports.sides.sell : 0
          } Sell`}
          text={activeTimeFilter.text}
          loading={reportLoading}
          icon="Crypto-Alerts2"
        />

        <StatisticsItem
          title="Your subscription Renew/expire "
          subject={
            typeof checkPlanExpire() === "string" ? (
              checkPlanExpire()
            ) : (
              <Moment utc fromNow>
                {plan.expired_at}
              </Moment>
            )
          }
          text="Remaining time"
          loading={false}
          icon="Subscribtion"
        />
      </Row>

      <Row>
        <Col lg={6} className="gutter-b">
          <TopFive
            title="🔥 Trending Coins"
            type="trending"
            limit="6"
            dashboard
          />
        </Col>

        <Col lg={6} className="gutter-b">
          <CoinEvents />
        </Col>

        <Col xs={12}>
          <TopTenWinners
            activeFilter={activeStatusFilter}
            setActiveFilter={(filter) => setActiveStatusFilter(filter)}
            activeTimeFilter={activeTimeFilter.text}
            items={topWinners}
            loading={topWinnerLoading}
          />
        </Col>
      </Row>
    </div>
  );
}

Dashboard.propTypes = {
  plan: PropTypes.object,
  showPlanModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  showPlanModal,
};

const mapStateToProps = (state) => ({
  plan: state.userReducer.plan,
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
